var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AboutUs_box1_inner"}},[_c('img',{attrs:{"src":require("../../../public/images/ContactUs/联系我们.png"),"alt":"联系我们","title":"联系我们"}})])
}]

export { render, staticRenderFns }